/**
 * Created by cedricgodefroy on 18/07/2017.
 */
/**
 * Created by cedricgodefroy on 18/07/2017.
 */
angular.module('FlexyBeautyApp.services').
    factory('DashboardSchedulerView',["DashboardScheduler","DashboardSchedulerData","DashboardSchedulerSrv",
        function (DashboardScheduler, DashboardSchedulerData,DashboardSchedulerSrv) {
            var DashboardSchedulerView = function (dashboardSchedulerModel, dashboardSchedulerIndex) {
                this.dashboardSchedulerIndex = dashboardSchedulerIndex;
                this.id = "";
                this.surname = null;
                this.type = null;
                this.object = null;
                this.message = null;
                this.dashboardId = null;
                this.sendTo = [];
                this.editMode = false;
                this.displayEmptyEmail = false;
                this.displayEmptyObject = false;
                this.displayEmptyMessage = false;
                this.displayEmptySurname = false;

                if (dashboardSchedulerModel) {
                    this.loadDataFrom(dashboardSchedulerModel);
                }
            };

            DashboardSchedulerView.prototype.loadDataFrom = function (dashboardSchedulerModel) {
                this.id = dashboardSchedulerModel.id;
                this.surname = dashboardSchedulerModel.surname;
                this.type = dashboardSchedulerModel.type;
                this.object = dashboardSchedulerModel.object;
                this.message = dashboardSchedulerModel.message;
                this.sendTo = [];
                for(var i = 0; i < dashboardSchedulerModel.sendTo.length; i++){
                    this.sendTo.push({ text: dashboardSchedulerModel.sendTo[i] });
                }
                this.dashboardId = dashboardSchedulerModel.dashboardId;
            };

            DashboardSchedulerView.prototype.isChanged = function(){
                let isSendToChanged = false,
                    dashboardSchedulerModel = this.getModel();
                if(dashboardSchedulerModel && dashboardSchedulerModel.sendTo.length === this.sendTo.length){
                    for(let i = 0; i < dashboardSchedulerModel.sendTo.length && !isSendToChanged; i++){
                        if(this.sendTo[i].text !== dashboardSchedulerModel.sendTo[i]){
                            isSendToChanged = true;
                        }
                    }
                }
                else{
                    isSendToChanged = true;
                }
                if (dashboardSchedulerModel){
                    return ((this.type !== dashboardSchedulerModel.type) ||
                        (this.object !== dashboardSchedulerModel.object) ||
                        (this.message !== dashboardSchedulerModel.message) ||
                        (isSendToChanged) ||
                        (this.surname !== dashboardSchedulerModel.surname));
                }
                else{
                    return true;
                }
            };

            DashboardSchedulerView.prototype.copyDataTo = function(dashboardScheduler) {
                dashboardScheduler.type = this.type;
                dashboardScheduler.object = this.object;
                dashboardScheduler.message = this.message;
                dashboardScheduler.dashboardId = this.dashboardId;
                dashboardScheduler.surname = this.surname;
                dashboardScheduler.sendTo = [];
                for(var i = 0; i < this.sendTo.length; i++){
                    dashboardScheduler.sendTo.push(this.sendTo[i].text);
                }
            };

            DashboardSchedulerView.prototype.getModel = function(){
                if (this.dashboardSchedulerIndex!=-1){
                    return DashboardSchedulerData.getByIndex(this.dashboardSchedulerIndex);
                }
                return null;
            };

            DashboardSchedulerView.prototype.updateModel = function(success, failure) {

                var dashboardScheduler = this.getModel();
                if (dashboardScheduler==null){
                    dashboardScheduler = new DashboardScheduler();
                    this.dashboardSchedulerIndex = DashboardSchedulerData.getIndexOf(dashboardScheduler);
                }

                this.copyDataTo(dashboardScheduler);

                DashboardSchedulerSrv.save(dashboardScheduler, success, failure);
            };

            DashboardSchedulerView.prototype.getSendToList = function() {
                var sendToListe = null;
                for(var i = 0 ; i < this.sendTo.length; i++){
                    if(sendToListe == null)
                        sendToListe = this.sendTo[i].text;
                    else
                        sendToListe += ", " + this.sendTo[i].text;
                }
                return sendToListe;
            };

            DashboardSchedulerView.prototype.reloadModel = function()
            {
                var dashboardScheduler = this.getModel();

                this.loadDataFrom(dashboardScheduler);
            };

            DashboardSchedulerView.prototype.canSave = function(){
                var canSave = true;

                if(!this.surname || this.surname == ""){
                    canSave = false;
                }
                if(!this.sendTo || this.sendTo.length == 0){
                    canSave = false;
                }
                if(!this.object || this.object == ""){
                    canSave = false;
                }
                return canSave;
            };

            DashboardSchedulerView.prototype.updateErrorEmail = function($tag){
                this.displayEmptyEmail = false;

                if(!this.sendTo || this.sendTo.length == 0){
                    this.displayEmptyEmail = true;
                }
            };

            DashboardSchedulerView.prototype.updateErrorObject = function($tag){
                this.displayEmptyObject = false;

                if(!this.object || this.object == ""){
                    this.displayEmptyObject = true;
                }
            };

            DashboardSchedulerView.prototype.updateErrorSurname = function($tag){
                this.displayEmptySurname = false;

                if(!this.surname || this.surname == ""){
                    this.displayEmptySurname = true;
                }
            };

            DashboardSchedulerView.prototype.updateError = function($tag){
                this.displayEmptyEmail = false;
                this.displayEmptyObject = false;
                this.displayEmptySurname = false;

                if(!this.sendTo || this.sendTo.length == 0){
                    this.displayEmptyEmail = true;
                }
                if(!this.object || this.object == ""){
                    this.displayEmptyObject = true;
                }
                if(!this.surname || this.surname == ""){
                    this.displayEmptySurname = true;
                }
            };

            return DashboardSchedulerView;
        }
    ]);


// WEBPACK FOOTER //
// ./js/services/views/statistics/report/DashboardSchedulerView.js